module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/vectors/term-bg-7-714635149e2d875880ce4baff62c6c6e.jpg";